import React from 'react';
import IconGraph from 'design-system/icons/IconGraph';
import IconPieChart from 'design-system/icons/IconPieChart';
import IconLineChart from 'design-system/icons/IconLineChart';
export const accountOverviewScreenTitleToSelectedAccountTitleMap = {
    Everyday: 'Everyday',
    Savings: 'Savings',
    Investments: 'Investments',
    'Net Worth - Main': 'Net worth',
    'Net Worth - Asset': 'Net worth',
    'Net Worth - Debt': 'Net worth',
};
/** Route params can come from a URL, so the title is not guaranteed to be valid. */
export const isAccountOverviewScreenTitle = (title) => typeof title === 'string' &&
    Object.prototype.hasOwnProperty.call(accountOverviewScreenTitleToSelectedAccountTitleMap, title);
export var ChartType;
(function (ChartType) {
    ChartType["pie"] = "pie";
    ChartType["line"] = "line";
    ChartType["assetVsDebt"] = "assetVsDebt";
})(ChartType || (ChartType = {}));
export const CHART_TYPE_ICONS = {
    [ChartType.pie]: <IconPieChart gradientKey="skyBlue"/>,
    [ChartType.line]: <IconLineChart alt/>,
    [ChartType.assetVsDebt]: <IconGraph gradientKey="darkPurple"/>,
};
export const CHART_TYPE_TITLE = {
    [ChartType.pie]: 'Pie chart',
    [ChartType.line]: 'Line chart',
    [ChartType.assetVsDebt]: 'Assets vs debt',
};
